export const GRADIENTS = {
  input: {
    login:
      'bg-gradient-to-r from-purple-600 via-pink-600 to-orange-500 hover:from-purple-700 hover:via-pink-700 hover:to-orange-600',
  },
  background: {
    base: 'bg-gradient-to-b from-gray-50 to-white border-r border-gray-200',
    light: 'bg-gradient-to-r from-gray-50 to-gray-100',
  },
  purple: {
    base: 'bg-gradient-to-r from-purple-600 to-pink-600 text-white',
    light: 'bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50',
    light100: 'bg-gradient-to-br from-purple-100 to-pink-100',
  },
  yellow: {
    base: 'bg-gradient-to-br from-yellow-400 to-yellow-600 text-white',
  },
  orange: {
    base: 'bg-gradient-to-br from-orange-500 via-pink-500 to-purple-600',
    light:
      'bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 transition-all',
  },
  green: {
    base: 'bg-gradient-to-r from-green-600 to-emerald-600 text-white',
    base500: 'bg-gradient-to-br from-green-500 to-emerald-500 text-white',
    light100: 'text-green-600 bg-gradient-to-br from-green-100 to-emerald-100',
  },
  blue: {
    base: 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white hover:from-blue-700 hover:to-cyan-700 hover:shadow-xl',
    light:
      'bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 shadow-blue-100/50',
    light100: 'text-blue-600 bg-gradient-to-br from-blue-100 to-cyan-100',
  },
  amber: {
    light:
      'bg-gradient-to-r from-amber-50 via-orange-50 to-pink-50 shadow-amber-100/50',
  },
  red: {
    base: 'bg-gradient-to-r from-red-600 to-orange-600',
    light: 'bg-gradient-to-br from-red-100 to-orange-100',
  },
};
